import { ZIP_PROBLEM_LABEL, type ZipProblem } from '@/components/sklad/materialTypes';
import { useState } from 'react';

/**
 * Kusy v Zadání do výroby, u kterých neumíme určit zip — rezervace u nich
 * chybí, takže sklad může vypadat lépe, než je. Ukazuje, co doplnit
 * (barvu u produktu, délku u kategorie, zip v Databázi zipů).
 */
export function ZipProblemsPanel({ problemy }: { problemy: ZipProblem[] }) {
  const [open, setOpen] = useState(false);
  if (problemy.length === 0) return null;
  const kusu = problemy.reduce((n, p) => n + p.qty, 0);

  return (
    <div className="mb-5 rounded-xl border border-warning/40 bg-warning-light px-5 py-3">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-3 text-left cursor-pointer"
      >
        <span className="text-sm font-semibold text-warning">
          ⚠️ U {kusu} ks ve výrobě neumíme určit zip ({problemy.length}{' '}
          {problemy.length === 1 ? 'velikost' : problemy.length <= 4 ? 'velikosti' : 'velikostí'}) —
          rezervace u nich chybí
        </span>
        <span className="text-sm text-warning shrink-0">{open ? 'Skrýt' : 'Zobrazit'}</span>
      </button>
      {open && (
        <div className="mt-3 max-h-72 overflow-y-auto rounded-lg bg-surface border border-border-light">
          <table className="w-full text-sm">
            <tbody>
              {problemy.map((p) => (
                <tr
                  key={`${p.product_code}|${p.variant_name ?? ''}`}
                  className="border-b border-border-light last:border-0"
                >
                  <td className="px-3 py-2 font-semibold text-text whitespace-nowrap">
                    {p.product_code}
                    {p.variant_name ? ` / ${p.variant_name}` : ''}
                  </td>
                  <td className="px-3 py-2 text-text-secondary whitespace-nowrap">{p.qty} ks</td>
                  <td className="px-3 py-2 text-text-secondary">
                    {ZIP_PROBLEM_LABEL[p.problem]}
                    {p.problem === 'neni_v_databazi' && (
                      <span className="text-text-muted">
                        {' '}
                        („{p.barva}" · „{p.delka}")
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
